import TaskInstancesCache from './TaskInstancesCache';
import filterTaskInstances from '../helpers/shiftTasks/filterTaskInstances';
import groupTaskInstances from '../helpers/shiftTasks/groupTaskInstances';
import { replaceArrayElement } from '../utils';
import {
  TASK_INSTANCE_PENDING_STATUS,
  TASK_INSTANCE_COMPLETED_STATUS,
  DEFAULT_TASK_INSTANCES_SORT_METHOD,
} from '../constants';

const knownStatuses = [TASK_INSTANCE_PENDING_STATUS, TASK_INSTANCE_COMPLETED_STATUS];

const TaskInstancesCollection = {
  range: null,

  get allInstances() {
    return TaskInstancesCache.getInstancesByRange(this.range) || [];
  },

  setInstancesAndRange(instances, range) {
    this.setRange(range);
    TaskInstancesCache.updateInstances(instances, range);
  },

  setRange(range) {
    this.range = range;
  },

  isRangeCached(range) {
    return TaskInstancesCache.isRangeCached(range);
  },

  edit(taskInstance) {
    const taskInstanceIndex = this.allInstances.findIndex((task) => task.id === taskInstance.id);
    if (taskInstanceIndex > -1) {
      const instance = {
        ...taskInstance,
        subtasks: taskInstance.subtasks?.filter((subtask) => !subtask.deleted),
      };
      const allInstances = replaceArrayElement(this.allInstances, taskInstanceIndex, instance);
      TaskInstancesCache.updateInstances(allInstances, this.range);
    }
  },

  remove(taskInstanceId) {
    const allInstances = this.allInstances.filter((task) => task.id !== taskInstanceId);
    TaskInstancesCache.updateInstances(allInstances, this.range);
    return allInstances;
  },

  findById(taskInstanceId) {
    return TaskInstancesCache.dict?.[taskInstanceId];
  },

  filterInstances(filters, query) {
    return filterTaskInstances(this.allInstances, filters, query);
  },

  groupInstances(taskInstances, groupMethod, sortMethod = DEFAULT_TASK_INSTANCES_SORT_METHOD) {
    return groupTaskInstances(taskInstances, groupMethod, sortMethod);
  },

  updateSingleInstance(instance) {
    TaskInstancesCache.updateSingleInstance(instance);
  },

  updateStatus(taskInstanceId, status) {
    if (!knownStatuses.includes(status)) {
      return;
    }
    const instance = this.findById(taskInstanceId);
    if (instance) {
      instance.status = status;
    }
  },

  updateSubtaskStatus(taskInstanceId, subtaskId, status) {
    if (!knownStatuses.includes(status)) {
      return;
    }

    const instance = this.findById(taskInstanceId);
    if (instance) {
      const subtask = this.findSubtaskById(instance, subtaskId);
      if (subtask) {
        subtask.status = status;
      }
    }

    return instance;
  },

  findSubtaskById(taskInstance, subtaskId) {
    return taskInstance.subtasks?.find(({ id }) => id === subtaskId);
  },

  findInstanceById(taskInstanceId) {
    return TaskInstancesCache.dict[taskInstanceId];
  },

  deleteInstancesByShiftId(shiftId) {
    TaskInstancesCache.deleteInstancesByShiftId(shiftId);
  },

  clearCache() {
    this.range = null;
    TaskInstancesCache.clear();
  },
};

export default TaskInstancesCollection;
